export default {
  nav: {
    findBarber: 'Najdi brivca'
  },
  navigation: {
    home: 'Domov',
    aboutUs: 'O nas',
    contactUs: 'Kontakt',
    demo: 'Demo',
    login: 'Prijava',
    language: 'Jezik',
    logo: 'Logotip',
    toggleMenu: 'Preklopi meni',
    changeLanguage: 'Spremeni jezik',
    scrollToTop: 'Skoči na vrh',
    joinAsBarber: 'Pridruži se kot brivec',
    pricing: 'Cenik',
    signUp: 'Prijava / Registracija'
  },
  home: {
    hero: {
      eyebrow: 'Trenutno sprejemamo v Sofiji - samo še 3 prosta mesta ta teden',
      mainTitle: 'Vaš stol.<br>Vaš urnik.<br><span class="hero-title-accent">Vaša rast.</span>',
      mainDesc: "Leta ste posvetili izpopolnjevanju svoje obrti. Svojih večerov ne bi smeli preživljati z odgovarjanjem na WhatsApp sporočila. Barbers Unity vam ponuja profesionalno stran za naročanje in pregleden koledar - da se lahko osredotočite na striženje, ne na lovljenje strank.",
      growBusiness: 'Želim več strank',
      seeDashboard: 'Poglej nadzorno ploščo',
      trustText: '<strong>Petar Barbov</strong> in ostali brivci po Evropi že uporabljajo našo platformo.',
      joinThem: 'Pridružite se jim →'
    },
    pain: {
      label: 'Vam to zveni znano?',
      answer: 'Barbers Unity poskrbi za vse to.',
      items: [
        'Klici strank, ravno ko ste sredi striženja',
        'Neprihodi strank (no-shows), ki vam zasedejo najboljše termine',
        'Pozabljate potrditi rezervacije na WhatsAppu',
        'Dvojne rezervacije, zaradi katerih izpadete neprofesionalni',
        'Uporaba papirnatega zvezka za naročanje v letu 2025'
      ]
    },
    mobile: {
      label: 'Upravljanje iz žepa',
      title: 'Vodite svojo brivnico od koderkoli.',
      desc: "Vaše delo ni za pisalno mizo. Barbers Unity je popolnoma optimiziran za vaš telefon. Preverite urnik, sprejmite rezervacije in preglejte zgodovino strank kar med posameznimi striženji.",
      list: [
        'Takojšnja obvestila o novih rezervacijah',
        'Hiter pregled celotne zgodovine stranke',
        'Dodajanje nenajavljenih strank v koledar v samo 3 sekundah'
      ]
    },
    featuresList: [
      { title: 'Vaša lastna stran za naročanje', desc: 'Profesionalna povezava, ki jo lahko delite kjerkoli - v Instagram opisu, na WhatsAppu, Googlu. Stranke se naročajo same, 24/7.' },
      { title: 'Pametni koledar', desc: 'Celoten teden na dlani. Blokirajte čas za malico, nastavite delovnik in se nikoli več ne ubadajte z dvojnimi rezervacijami.' },
      { title: 'Baza strank', desc: "Zgodovina in kontaktni podatki vsake stranke - organizirano, enostavno za iskanje in vedno na dosegu roke." },
      { title: 'Mednarodna platforma', desc: 'Ustvarjena za brivce po vsej Evropi. Podpira SI, EN, BG, HR, ALB, GER in se še širi.' }
    ],
    calendar_preview: {
      title: 'Vaš koledar, na kateri koli napravi.'
    },
    how: {
      label: 'Kako začeti',
      title: 'Pripravljeni na delo v manj kot 10 minutah'
    },
    stepsList: [
      { title: 'Ustvarite svoj profil', desc: 'Prijavite se v nekaj minutah. Dodajte svoje storitve, nastavite delovni čas in takoj pridobite svojo profesionalno povezavo za naročanje. Tehnično znanje ni potrebno.' },
      { title: 'Delite svojo povezavo za naročanje', desc: 'Prilepite jo v svoj Instagram opis, WhatsApp status ali pa jo pošljite rednim strankam. Naročijo se lahko v nekaj sekundah.' },
      { title: 'Samo pridite in strizite', desc: 'Koledar se upravlja sam. Vi se samo osredotočite na striženje in grajenje svojega imena.' }
    ],
    trust: {
      card1: { title: 'Mi opravimo težje delo', desc: "Se bojite zamenjave sistema? Brez skrbi. Pošljite nam vaš obstoječi seznam strank (Excel, Booksy izvoz ali fotografije starega zvezka) in brezplačno bomo uvozili vaše stranke ter ustvarili vaš profil." },
      card2: { title: '100% lastništvo podatkov', desc: 'Druge platforme uporabljajo vaše stranke za promocijo konkurenčnih brivcev. Pri Barbers Unity je vaš seznam strank izključno vaš. Vaših podatkov ne prodajamo in vašim strankam nikoli ne pošiljamo oglasov.' }
    },
    testimonial: {
      quote: "Pred Barbers Unity sem izgubljal 3 do 4 stranke na teden samo zaradi zgrešenih klicev in WhatsApp sporočil, na katera sem pozabil odgovoriti. Pri 20 € na striženje je to 240-320 €, ki sem jih izgubljal vsak mesec. Zdaj se moj koledar polni sam od sebe. Jaz samo pridem in strižem.",
      name: 'Petar Barbov',
      role: 'Profesionalni brivec · Zgodnji član'
    },
    stats: {
      label: 'Aktivnost platforme',
      title: 'Resnične številke, ki rastejo vsak dan',
      bookings: 'Opravljenih rezervacij',
      clients: 'Postriženih strank',
      time: 'Prihranjen čas za administracijo na brivca / teden'
    },
    pricing: {
      label: 'Poštene cene',
      title: "Ne plačujte provizije na lasten uspeh",
      desc: 'Ostale platforme vas kaznujejo, ko imate več dela, tako da vam zaračunavajo na rezervacijo. Mi verjamemo, da to, kar zaslužite, ostane v vašem žepu.',
      competitorNote: 'Ko konkurenčni brivec v vašem mestu prevzame svoje mesto, pridobi prednost. Prvi brivec na posameznem območju dobi prednostno pozicijo pri iskanju.',
      identityLine: 'Ustvarjeno za brivce, ki svoje delo jemljejo kot posel in ne kot hobi.',
      them: {
        label: 'Konkurenca',
        list: [ 'Zaračunavanje na rezervacijo', 'Skriti stroški in nepričakovana plačila', 'Stroški rastejo, ko ste bolj zasedeni' ],
        price: 'Do 200 €',
        sub: '/mesec'
      },
      vs: 'PROTI',
      us: {
        label: 'Barbers Unity',
        list: [ 'Neomejeno število rezervacij', 'Brez provizij in brez skritih stroškov', 'Obdržite 100 % svojega zaslužka' ],
        price: '35 €',
        sub: '/mesec fiksno'
      }
    },
    calc: {
      label: 'Kalkulator prihodkov',
      title: "Poglejte, koliko denarja puščate na mizi",
      desc: 'Vsak zgrešen termin pomeni manj denarja. Premaknite drsnike in poglejte, koliko več bi lahko zaslužili vsak mesec.',
      button: 'Začni služiti več',
      cuts: 'Striženj na dan',
      price: 'Cena posameznega striženja (€)',
      missed: 'Zgrešenih terminov na teden',
      monthlyNow: 'Vaš trenutni mesečni prihodek',
      withUs: 'Z Barbers Unity',
      recovered: '/ mesec povrnjenega prihodka',
      lossThisMonth: 'že izgubljeno ta mesec'
    },
    faq: {
      label: 'Imate vprašanja?',
      title: 'Pogosta vprašanja'
    },
    faqList: [
      { q: "Ali si morajo moje stranke naložiti aplikacijo?", a: "Ne! Vaše stranke se naročijo preko čiste in hitre povezave neposredno v svojem brskalniku. Brez nalaganja aplikacij, brez ustvarjanja uporabniških računov in brez nepotrebnih ovir." },
      { q: "Kako prejemam plačila?", a: "Obdržite 100 % tistega, kar zaslužite. Stranke vam plačajo neposredno v brivnici, tako kot vedno. Od vašega dela ne vzamemo nobenega odstotka ali provizije." },
      { q: "Ali me veže dolgoročna pogodba?", a: "Absolutno ne. Barbers Unity deluje na podlagi fiksne mesečne naročnine. Odjavite se lahko kadarkoli želite." },
      { q: "Trenutno že uporabljam drug sistem. Je težko zamenjati?", a: "Od vas to ne zahteva nobenega truda. Pošljite nam svoj trenutni seznam strank in popolnoma brezplačno bomo uvozili vse podatke ter vam postavili profil." }
    ],
    upcoming: {
      label: 'Kmalu',
      title: 'Prihaja še več zmogljivih orodij',
      badge: 'Kmalu'
    },
    upcomingList: [
      { title: 'Avtomatski opomniki', desc: 'Email in WhatsApp opomniki, poslani pred vsakim terminom - neprihodi strank bodo postali preteklost.' },
      { title: 'Analitika in pregled prihodkov', desc: 'Poglejte svoje najbolj dobičkonosne storitve, najbolj obremenjene ure in redne stranke - sprejemajte pametnejše odločitve za svoj posel.' },
      { title: 'Sistem zvestobe', desc: 'Nagrajujte redne stranke, spremljajte njihove obiske in poskrbite, da se radi vračajo z našim vgrajenim sistemom.' }
    ],
    cta: {
      eyebrow: 'Omejeno število mest - rezervirajte predno se zapolnijo',
      title: 'Ste pripravljeni zapolniti svoj urnik?',
      sub: 'Pridružite se brivcem, ki obvladujejo svoj posel – in ne obratno.',
      microYes: [
        'Želim vsak teden popolnoma zaseden koledar',
        'Ne želim več neprihodov strank (no-shows)',
        "Nočem se več iti receptorja"
      ],
      findBarber: 'Najdi brivca v bližini',
      member: 'Ste že član?',
      login: 'Prijavite se v nadzorno ploščo →'
    },
    pricingCta: {
      title: 'Ste pripravljeni na rast vaše brivnice?',
      subtitle: '35 €/mesec · Prvi mesec brezplačno',
      button: 'Začni zdaj'
    }
  },
  about: {
    title: 'O podjetju Barbers Unity',
    description: "Korenito spreminjamo način, kako se brivci povezujejo s svojimi strankami. Naša platforma pomaga brivcem pri predstavitvi njihovega dela, enostavnem upravljanju urnikov in učinkoviti rasti njihovega poslovanja.",
    founded: 'Ustanovljeno leta 2025. Barbers Unity je iz preproste ideje prerasel v celovito platformo, ki služi brivcem v več različnih državah.',
    ourStory: 'Naša zgodba',
    whatDrivesUs: 'Kaj nas žene',
    mission: {
      title: 'Naše poslanstvo',
      description: 'Poenostaviti in posodobiti proces naročanja za brivce.'
    },
    vision: {
      title: 'Naša vizija',
      description: 'Ustvariti največjo skupnost med seboj povezanih brivcev na svetu.'
    },
    values: {
      title: 'Naše vrednote',
      description: 'Kakovost, zaupanje in profesionalna rast.'
    },
    built: {
      label: 'Narejeno za obrt',
      title: 'Vemo, kako je stati za brivskim stolom.',
      desc1: "Platforma Barbers Unity ni bila ustvarjena v korporativnih pisarnah. Naredili smo jo, ker smo videli izjemne brivce - talentirane, iskane in spoštovane -, ki so izgubljali stranke zaradi neodgovorjenih klicev in nerodnih sistemov za naročanje, ki niso bili narejeni zanje.",
      desc2: "Zgradili smo platformo, ki bi si jo sami želeli: takšno, ki vašo obrt jemlje resno, postavlja vaše ime na prvo mesto in namesto vas poskrbi za administracijo, da se vam s tem ni treba ukvarjati.",
      stats: {
        countries: 'Države, v katerih delujemo',
        time: 'Čas do zagona profila',
        cost: 'Strošek nastavitve'
      }
    },
    testimonial: {
      quote: "Pred Barbers Unity sem izgubljal 3 do 4 stranke na teden samo zaradi zgrešenih klicev in WhatsApp sporočil, na katera sem pozabil odgovoriti. Pri 20 € na striženje je to 240-320 €, ki sem jih izgubljal vsak mesec. Zdaj se moj koledar polni sam od sebe. Jaz samo pridem in strižem.",
      name: 'Petar Barbov',
      role: 'Profesionalni brivec · Zgodnji član'
    },
    timeline: {
      label: 'Časovnica',
      title: 'Gradimo nekaj večjega.',
      items: [
        { year: '2025', event: 'Ustanovitev Barbers Unity - ideja se je rodila iz frustracij zaradi neskončnega zvonjenja telefonov in zgrešenih terminov.' },
        { year: '2025', event: 'Lansiranje platforme v Beta verziji.' },
        { year: 'Danes', event: 'Širimo mrežo - več brivcev, več mest, boljša orodja za vse.' }
      ]
    },
    cta: {
      eyebrow: 'Omejena mesta - rezervirajte predno se zapolnijo',
      title: 'Želite postati del naše zgodbe?',
      description: "Ne glede na to, ali ste brivec ali stranka, v skupnosti Barbers Unity se vedno najde mesto za vas.",
      findBarber: 'Najdi brivca',
      getInTouch: 'Stopite v stik z nami'
    }
  },
  contact: {
    title: 'Kontaktirajte nas',
    getInTouch: {
      title: 'Stopite v stik z nami',
      description: 'Imate vprašanja o platformi Barbers Unity? Tukaj smo, da vam pomagamo! Oglasite se nam na kateremkoli izmed naših socialnih omrežij ali pa nam pošljite direktno sporočilo.',
      info: "Imate vprašanja? Z veseljem vam pomagamo - pišite nam na katerega izmed spodnjih kanalov."
    },
    followUs: 'Sledite nam',
    b2b: {
      text: "<strong>Ste brivec?</strong> Preskočite obrazec - rezervirajte brezplačen 20-minutni klic in skupaj bomo vse nastavili.",
      button: 'Rezerviraj brezplačen klic'
    },
    success: {
      title: 'Sporočilo poslano!',
      desc: "Hvala za vaše sporočilo. Odgovorili vam bomo v najkrajšem možnem času.",
      button: 'Pošlji novo sporočilo'
    },
    form: {
      name: 'Ime',
      namePlaceholder: 'Vaše ime',
      email: 'Email',
      emailPlaceholder: 'vas@email.com',
      message: 'Sporočilo',
      messagePlaceholder: 'Povejte nam, kako vam lahko pomagamo...',
      send: 'Pošlji sporočilo'
    }
  },
  forBusiness: {
    hero: {
      eyebrow: 'Omejena mesta - trenutno sprejemamo nove brivce',
      mainTitle: 'Nehajte voditi svoj posel<br><span class="title-accent">peš.</span>',
      mainDesc: 'Vsak zgrešen klic je denar, ki vam polzi skozi prste. Vsak neprihod stranke (no-show) uniči dragocen termin. Barbers Unity vam ponuja profesionalen sistem, ki ohranja vaš koledar poln, stranke pa vedno obveščene.',
      bookCall: 'Rezerviraj brezplačen nastavitveni klic',
      seeDashboard: 'Poglej nadzorno ploščo',
      trust: ['Brezplačna nastavitev', 'Brez pogodb', 'Pripravljeni na delo v 10 minutah']
    },
    loss: {
      beforeLabel: 'Brez Barbers Unity',
      afterLabel: 'Z Barbers Unity',
      without: [
        'Zgrešeni klici med striženjem',
        'Neprihodi strank, ki pustijo prazne termine',
        'Ročno potrjevanje vsake posamezne rezervacije',
        'Nepregledni zvezki ali zmedene Excel tabele',
        'Uganjanje, katere storitve vam prinašajo največ dobička'
      ],
      with: [
        'Stranke se naročajo same preko spleta, 24/7',
        'Koledar se posodablja v živo, brez vašega truda',
        'Profesionalna nadzorna plošča, ki je vedno urejena',
        'Celotna zgodovina naročil in pregled storitev',
        'Deluje v več državah in več jezikih'
      ]
    },
    features: {
      label: 'Kaj dobite',
      heading: 'Vse, kar potrebuje profesionalen brivec',
      items: [
        { title: 'Vaša profesionalna stran za naročanje', desc: 'Čista in pregledna povezava z vašim imenom, ki jo lahko delite povsod - Instagram, WhatsApp, Google. Stranke vidijo storitve, cene, proste termine in se naročijo same. Nič več nepotrebnih klicev in neskončnega dopisovanja.', badge: 'Pripravljeno v nekaj minutah' },
        { title: 'Popoln koledar samo za brivce', desc: 'Zablokirajte si čas za malico, nastavite svoj delovni čas in upravljajte z različno dolgimi storitvami. Imejte pregled nad celotnim tednom in nikoli več ne podvojite terminov.', badge: null },
        { title: 'Zgodovina strank in njihove želje', desc: "Zgodovina preteklih striženj, kontaktni podatki in zapiski pri vsaki stranki - vse na enem mestu. Vedite natančno, kaj stranka želi, preden sploh sede na stol.", badge: null },
        { title: 'Avtomatski opomniki (kmalu)', desc: 'Pred vsakim terminom se avtomatsko pošljejo Email in WhatsApp opomniki. Neprihodi strank ne bodo več vaš problem. Na voljo zelo kmalu.', badge: 'Kmalu' }
      ]
    },
    why: {
      label: 'Zakaj nas izberejo brivci',
      heading: 'Vaš stol.<br>Vaša pravila.<br>Vaš dobiček.',
      body: 'Barbers Unity vaš posel postavi pred stranke, ki aktivno iščejo brivca - brez da bi jih morali prositi, loviti ali se s tem obremenjevati.',
      list: [
        'Nič iskanja strank – stranke pridejo k vam',
        'Vse nastavimo na 20-minutnem klicu, popolnoma brezplačno',
        'Odlično sodeluje z vašim trenutnim WhatsAppom in e-mailom',
        "Brez vezave – odidete lahko kadarkoli (pa ne boste hoteli)",
        'Podpora s strani resničnih ljudi, ne pogovornih robotov (botov)'
      ],
      highlights: [
        { title: 'Takojšnja postavitev', desc: "20-minutni klic. Pripravljeni ste na delo preden sploh odložite telefon." },
        { title: 'Narejeno za brivce', desc: 'Oblikovano v sodelovanju z brivci – ne samo za njih.' },
        { title: 'Večjezičnost', desc: 'SI, EN, BG, HR, ALB, GER - ne glede na to kje delate.' },
        { title: 'Brez vezave', desc: 'Začnite brezplačno. Ostanite z nami, ker deluje, ne ker ste prisiljeni.' }
      ]
    },
    testimonial: {
      quote: "Pred Barbers Unity sem izgubljal 3 do 4 stranke na teden samo zaradi zgrešenih klicev in WhatsApp sporočil, na katera sem pozabil odgovoriti. Pri 20 € na striženje je to 240-320 €, ki sem jih izgubljal vsak mesec. Zdaj se moj koledar polni sam od sebe. Jaz samo pridem in strižem.",
      name: 'Petar Barbov',
      role: 'Profesionalni brivec · Zgodnji član'
    },
    cta: {
      eyebrow: 'Sprejemamo v Sofiji - samo še 3 prosta mesta ta teden',
      mainTitle: 'Ste pripravljeni na popolnoma poln urnik?',
      sub: "Rezervirajte si brezplačen 20-minutni klic. Skupaj bomo nastavili vse potrebno – vaš profil, storitve in koledar. Lahko boste začeli sprejemati stranke še pred koncem našega klica.",
      bookCall: 'Rezerviraj moj brezplačen klic',
      member: 'Ste že član?',
      login: 'Prijavite se v nadzorno ploščo →'
    }
  },
  footer: {
    description: 'Povezujemo brivce z njihovimi strankami, poenostavljamo naročanje in pomagamo pri rasti poslovanja.',
    quickLinks: {
      title: 'Hitre povezave',
      about: 'O nas',
      contact: 'Kontakt',
      demo: 'Demo'
    },
    legal: {
      title: 'Pravno obvestilo',
      privacy: 'Politika zasebnosti',
      terms: 'Pogoji uporabe'
    },
    followUs: 'Sledite nam',
    social: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      tiktok: 'TikTok'
    },
    copyright: '© 2025 BarbersUnity. Vse pravice pridržane.'
  },
  tailwindMessage: "Tailwind CSS deluje v Vue 3! 🎉",
  clickMe: "Klikni tukaj",
  previous: 'Nazaj',
  notFound: {
    title: 'Stran ne obstaja',
    description: "Stran, ki jo iščete, ne obstaja ali pa je bila premaknjena.",
    backHome: 'Nazaj na vstopno stran'
  },
  cookies: {
    title: 'Nastavitve piškotkov',
    message: 'Piškotke uporabljamo za izboljšanje vaše uporabniške izkušnje, analizo prometa na spletnem mestu in prikazovanje prilagojene vsebine. Z nadaljnjo uporabo našega spletnega mesta se strinjate z uporabo piškotkov.',
    decline: 'Zavrni',
    accept: 'Sprejmi vse'
  },
  map: {
    eyebrow: 'Najdi brivca',
    heading: 'Brivci v vaši bližini',
    searchPlaceholder: 'Iskanje po mestu ali imenu brivca...',
    loading: 'Nalaganje zemljevida...',
    error: {
      title: 'Zemljevida ni bilo mogoče naložiti',
      desc: 'Pri nalaganju zemljevida je prišlo do težave. Prosimo, poskusite znova.',
      retry: 'Poskusi znova'
    },
    results: 'rezultatov',
    result: 'rezultat',
    bookNow: 'Naroči se'
  },
  privacy: {
    intro: 'Dobrodošli na Barbers Unity. Spoštujemo vašo zasebnost in smo zavezani k varovanju vaših osebnih podatkov. Ta politika zasebnosti vas obvešča o tem, kako skrbimo za vaše podatke, ko obiščete našo stran, o vaših pravicah glede zasebnosti in kako vas ščiti zakon.',
    sections: {
      collect: {
        title: '1. Podatki, ki jih zbiramo',
        desc: 'Lahko zbiramo, uporabljamo, shranjujemo in prenašamo različne vrste osebnih podatkov o vas, ki smo jih razvrstili v naslednje skupine:',
        items: [
          '<strong>Podatki o identiteti</strong> vključujejo ime, priimek, uporabniško ime ali podoben identifikator.',
          '<strong>Kontaktni podatki</strong> vključujejo e-poštni naslov in telefonske številke.',
          '<strong>Tehnični podatki</strong> vključujejo naslov internetnega protokola (IP), vrsto in različico brskalnika, časovni pas ter drugo tehnologijo na napravah, ki jih uporabljate za dostop do te spletne strani.'
        ]
      },
      use: {
        title: '2. Kako uporabljamo vaše podatke',
        desc: 'Vaše osebne podatke bomo uporabili samo, ko nam to dovoljuje zakon. Najpogosteje bomo vaše podatke uporabili v naslednjih okoliščinah:',
        items: [
          'Kadar moramo izpolniti pogodbo, ki jo bomo sklenili ali smo jo sklenili z vami (npr. ob rezervaciji termina).',
          'Kadar je to potrebno za naše zakonite interese in vaši interesi ali temeljne pravice ne prevladajo nad temi interesi.',
          'Kadar moramo izpolniti zakonsko obveznost.'
        ]
      },
      contact: {
        title: '3. Kontaktirajte nas',
        desc: 'Če imate kakršnakoli vprašanja o tej politiki zasebnosti ali naših praksah, nam prosim pišite preko naših kontaktnih kanalov.'
      }
    }
  },
  pricing: {
    title: 'Preprost cenik',
    subtitle: 'En paket. Vse vključeno. Prvi mesec brezplačno.',
    price: '35',
    period: '/mesec',
    trial: 'Prvi mesec BREZPLAČNO',
    cta: 'Začnite brezplačni preizkus',
    features: [
      'Neomejeno število rezervacij',
      'Obvestila strankam',
      'QR koda in generator zgodb',
      'Koledar za več zaposlenih',
      'Nadzorna plošča z analitiko',
      'Prednostna podpora'
    ]
  },
  terms: {
    title: 'Pogoji uporabe',
    intro: 'Dobrodošli na Barbers Unity. Z uporabo naše platforme se strinjate s temi pogoji. Prosimo, da jih natančno preberete.',
    sections: {
      account: {
        title: '1. Registracija računa',
        desc: 'Pri ustvarjanju računa morate navesti točne podatke. Odgovorni ste za varno shranjevanje svojih prijavnih podatkov.'
      },
      usage: {
        title: '2. Sprejemljiva uporaba',
        desc: 'Strinjate se, da platforme ne boste zlorabljali, motili njenega normalnega delovanja ali poskušali dostopati do nje na način, ki ni vmesnik, ki ga ponujamo.'
      },
      fees: {
        title: '3. Naročnina in pristojbine',
        desc: 'Naše storitve se zaračunavajo na podlagi naročnine. Vse pristojbine so nevračljive, razen če zakon določa drugače.'
      },
      liability: {
        title: '4. Omejitev odgovornosti',
        desc: 'Barbers Unity je na voljo "kot je". Ne odgovarjamo za nobeno posredno, naključno ali posledično škodo, ki bi nastala zaradi vaše uporabe platforme.'
      }
    }
  },
  loading: {
    title: 'Nalaganje...',
    message: 'Prosimo, počakajte'
  },
  modal: {
    registerTitle: 'Izberite vrsto računa',
    businessTitle: 'Registracija za podjetja',
    businessDesc: 'Salon / Brivec',
    customerTitle: 'Registracija za stranke',
    customerDesc: 'Rezervacija terminov'
  }
}